// src/functions/profanity.js
// Lightweight client-side profanity filter for Word Cloud responses.
// Not exhaustive — a reasonable default block list. Extend as needed.

const BLOCKLIST = [
  "fuck", "shit", "bitch", "asshole", "bastard", "dick", "piss", "cunt",
  "slut", "whore", "fag", "nigger", "nigga", "retard", "crap", "damn",
  "prick", "wanker", "bollocks", "twat", "arse",
];

// Normalize common leetspeak substitutions so "sh1t" etc. are caught.
function normalize(word) {
  return String(word || "")
    .toLowerCase()
    .replace(/[@]/g, "a")
    .replace(/[$]/g, "s")
    .replace(/[0]/g, "o")
    .replace(/[1!]/g, "i")
    .replace(/[3]/g, "e")
    .replace(/[^a-z ]/g, "");
}

export function isProfane(text) {
  const norm = normalize(text);
  if (!norm) return false;
  const tokens = norm.split(/\s+/);
  return tokens.some((t) => BLOCKLIST.includes(t)) ||
    BLOCKLIST.some((bad) => norm.includes(bad));
}

export default isProfane;
